// CMS series belong to one story/layout snapshot. Never join across scopes.
export function chartRecordsForMarket(chartData, marketId) {
  return (Array.isArray(chartData) ? chartData : [])
    .filter((series) => series && Number(series.marketId) === Number(marketId))
    .flatMap((series) =>
      (Array.isArray(series.points) ? series.points : [])
        .filter((point) => point && typeof point.date === 'string')
        .map((point) => ({
          contractId: Number(series.contractId),
          date: point.date,
          closeSharePrice: point.price,
        })),
    );
}
